<template>
  <v-container>
    <v-item-group
      v-model="branch"
    >
      <v-item
        v-for="(item, index) in branches"
        :key="index"
        :value="item.id"
      >
        <template v-slot="{ active, toggle }">
          <v-btn
            class="mr-2"
            :outlined="!active"
            color="primary"
            @click="toggle"
          >
            <v-icon class="mr-1">mdi-home</v-icon>
            <span>{{ item.name }}</span>
          </v-btn>
        </template>
      </v-item>
    </v-item-group>
    <v-card
      min-height="75vh"
    >
      <v-card-title>

      </v-card-title>
      <v-overlay
        :value="changingBranch"
        absolute
        dark
        color="primary"
      >
        <div
          style="
            content: '';
            min-width: 70vw;
          "
          class="text-h1 text-uppercase transparent--text"
        ></div>
        <v-progress-linear
          indeterminate
          color="primary"
          height="20"
          dark
          top
          rounded
          background-color="transparent"
        >
        </v-progress-linear>
      </v-overlay>
      <router-view></router-view>
    </v-card>
  </v-container>
</template>
<script>
  import { mapState } from 'vuex'
  import searchDelay from '@/extra-functions/searchDelay.extra'
  const refreshPage = searchDelay(1000)

  export default {
    name: 'stores',
    data () {
      return {
        branch: null,
        changingBranch: false,
      }
    },
    computed: {
      ...mapState({
        branches: state => state.branchLocation.list,
      }),
    },
    watch: {
      branch (val) {
        this.changingBranch = true
        refreshPage(() => {
          this.changingBranch = false
          if (!val) {
            this.$router.push('/stores')
          } else {
            this.$router.push(`/stores/${val}`)
          }
        })
      },
    },
  }
</script>
